import { render } from "./Sidebar.vue?vue&type=template&id=35adc705&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=35adc705&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=35adc705&lang=scss&scoped=true"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35adc705"]])

export default __exports__